import React from 'react';
import backgroundImage from '../images/background.jpg'

const Background = () => {
  return (
    <div className="background" style={{ 
      backgroundImage: `url(${backgroundImage})` 
    }}>

    </div>
  )
}

export default Background;